
import Empty from './index.vue'

Empty.install = function (Vue) {
  Vue.component(Empty.name, Empty)
}

export default Empty